<script>
export default {
    components: {},
    computed: {},
    watch: {},
    data() {
        return {
            loading: false
        }
    },
    methods: {},
}
</script>

<template>
    <div>
        <header-image kicker="Cars and Tracks">
            <h1>Browse Cars &amp; Tracks</h1>
        </header-image>

        <b-container class="mt-3 mb-5" v-if="!loading">
            <router-view />
        </b-container>
    </div>
</template>

<style lang="scss" scoped>
</style>
